// extracted by mini-css-extract-plugin
export default {"route-specific":"RouterStyles_route-specific__vEHb7"};